"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var d3 = _interopRequireWildcard(require("d3"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RadialChart = /*#__PURE__*/function (_Component) {
  _inherits(RadialChart, _Component);

  var _super = _createSuper(RadialChart);

  function RadialChart() {
    _classCallCheck(this, RadialChart);

    return _super.apply(this, arguments);
  }

  _createClass(RadialChart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          thickness = _this$props.thickness,
          data = _this$props.data,
          theme = _this$props.theme,
          colors = _this$props.colors,
          fontSize = _this$props.fontSize,
          bgColor = _this$props.bgColor,
          noStroke = _this$props.noStroke,
          inverted = _this$props.inverted;
      var radius = this.props.radius || width / 3.6; // Compute geometric angles

      var values = data.map(function (d) {
        return d.value;
      });
      var angles = d3.pie().sort(null)(values); // Compute colors

      if (!colors) {
        colors = inverted ? theme.data.secondary : theme.data.primary;
      } // Zip slice and angle data into single collection


      var sliceData = data.map(function (dataItem, i) {
        return _objectSpread(_objectSpread(_objectSpread({}, dataItem), angles[i]), {}, {
          fill: dataItem.fill || colors[i % colors.length]
        });
      }); // Compute geometrical paths

      var path = d3.arc().outerRadius(radius - 10);
      var labelArc = d3.arc().outerRadius(radius + 5).innerRadius(radius + 5); // If thickness provided add innerRadius (radial chart instead of old-school pie)

      if (thickness) {
        path = path.innerRadius(radius - thickness);
      } else {
        path = path.innerRadius(0);
      } // Generate slices (SVG paths)


      var stroke = inverted ? theme.inverted.two[0] : theme.inverted.two[4];
      var arcProps = noStroke ? {} : {
        stroke: stroke,
        strokeWidth: 2
      };
      var arcs = sliceData.map(function (slice, i) {
        return /*#__PURE__*/_react.default.createElement("path", _extends({
          fill: slice.fill,
          key: i,
          d: path(slice)
        }, arcProps));
      }); // Generate labels (SVG texts)

      var labels = sliceData.map(function (g, i) {
        if (g.value > 0) {
          var middleAngle = g.startAngle + (g.endAngle - g.startAngle) / 2.0;
          var isLeft = middleAngle > Math.PI;
          return /*#__PURE__*/_react.default.createElement("text", {
            key: i,
            transform: "translate(".concat(labelArc.centroid(g), ")"),
            textAnchor: isLeft ? 'end' : 'start',
            fontFamily: "LL Circular Book Web",
            fontSize: fontSize,
            fill: inverted ? theme.inverted.one[0] : theme.one[0]
          }, g.title && /*#__PURE__*/_react.default.createElement("title", null, g.title), g.label);
        } else {
          return null;
        }
      });
      var bg;

      if (bgColor) {
        bg = /*#__PURE__*/_react.default.createElement("rect", {
          width: "100%",
          height: "100%",
          fill: bgColor
        });
      } // Wrap in SVG translating origin of chart to center of drawing


      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height
      }, bg, /*#__PURE__*/_react.default.createElement("g", {
        transform: "translate(".concat(width / 2, ",").concat(height / 2, ")")
      }, /*#__PURE__*/_react.default.createElement("g", null, arcs), /*#__PURE__*/_react.default.createElement("g", null, labels)));
    }
  }]);

  return RadialChart;
}(_react.Component);

_defineProperty(RadialChart, "defaultProps", {
  inverted: false,
  width: 300,
  height: 300,
  fontSize: 14
});

var _default = (0, _styledComponents.withTheme)(RadialChart);

exports.default = _default;
//# sourceMappingURL=RadialChart.js.map